import { appIcons } from 'constants/known-apps.icons';
import type { TicMeta } from 'types/tic';

/**
 * Enriches entity's TicMeta with derived fields.
 * Adds icon URL from tool_id lookup, falling back to favicon service.
 * Returns original entity if no enrichment needed.
 */
export function enrichTicMeta<T extends { tic?: TicMeta }>(entity: T): T {
  const { tic } = entity;

  if (!tic?.tool_id || tic.icon) {
    return entity;
  }

  // First try static icon lookup
  let icon = appIcons[tic.tool_id];

  // Fall back to favicon service if we have an external URL
  if (!icon && tic.external_url) {
    try {
      const hostname = new URL(tic.external_url).hostname;
      if (hostname) {
        icon = `https://icons.timelyapp.com/favicons/${hostname}?size=64`;
      }
    } catch {
      // Invalid URL, no fallback
    }
  }

  if (!icon) {
    return entity;
  }

  return {
    ...entity,
    tic: { ...tic, icon },
  };
}
